export default __webpack_public_path__ + "static/media/H1015.5.1d0f4925.mp3";